// import ReviewChart from 'pages/Review/components/ReviewChart'
import { Box } from '@mui/material'
import React from 'react'
import Cards from './components/Cards'
import LoyalMetrics from './components/LoyaltyMetric/LoyalMetrics'
import LineChart from './components/OverviewChart/Chart'
// import OverviewTable from './components/OverviewTable'
import ReviewOverview from './components/ReviewOverview/ReviewOverview'

export default function Overview() {
  return (
    <>
      <Cards />

      <LineChart />
      <Box className='flex gap-[50px] border ' sx={{ flexDirection: { xs: 'column', lg: 'row' } }}>

        <LoyalMetrics />

        <ReviewOverview />
      </Box>
      {/* <OverviewTable /> */}
      {/* <ReviewChart /> */}
    </>
  )
}
